import { DialogHeader, DialogTitle } from "@repo/ui";
import type { TaskManagerDTO } from "~/types/api-custom";
import { TaskForm } from "./task-form/task-form";

type Props = {
  task?: TaskManagerDTO;
  onClose?: () => void;
};

export const TaskDialog = ({ task, onClose }: Props) => {
  const isEditMode = !!task;

  return (
    <div className="flex flex-col gap-4">
      <DialogHeader>
        <DialogTitle>{isEditMode ? "Edit Task" : "Create Task"}</DialogTitle>
      </DialogHeader>
      <div>
        <TaskForm task={task} onClose={onClose} />
      </div>
    </div>
  );
};
